import { useNavigate } from "react-router-dom";
import ProviderList from "../../features/manageServiceProvider/providerList";

const ManageServiceProviders = () => {

  const navigate = useNavigate();

  return (
    <>
      <div className="main_title">
        <h1>Manage Service Providers</h1>
        <p>
          <button onClick={() => navigate("/dashboard")}>Dashboard</button> - Manage Sub-Admin
        </p>
      </div>
      
     
      
        <ProviderList />
  
    </>
  );
};

export default ManageServiceProviders;
